import(/* webpackMode: "eager" */ "/var/www/azia_frontv2_v3/src/app/error.tsx");
